/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

export const countries = [
  { name: "United Arab Emirates", taxType: "ae_trn", abbr: "AE" },
  { name: "Australia", taxType: "au_abn", abbr: "AU" },
  { name: "Brazil", taxType: "br_cnpj", abbr: "BR" },
  { name: "Brazil", taxType: "br_cpf", abbr: "BR" },
  { name: "Canada", taxType: "ca_bn", abbr: "CA" },
  { name: "Canada", taxType: "ca_qst", abbr: "CA" },
  { name: "Switzerland", taxType: "ch_vat", abbr: "CH" },
  { name: "Chile", taxType: "cl_tin", abbr: "CL" },
  { name: "Spain", taxType: "es_cif", abbr: "ES" },
  { name: "Austria", taxType: "eu_vat", abbr: "AT" },
  { name: "Belgium", taxType: "eu_vat", abbr: "BE" },
  { name: "Bulgaria", taxType: "eu_vat", abbr: "BG" },
  { name: "Cyprus", taxType: "eu_vat", abbr: "CY" },
  { name: "Czech Republic", taxType: "eu_vat", abbr: "CZ" },
  { name: "Germany", taxType: "eu_vat", abbr: "DE" },
  { name: "Denmark", taxType: "eu_vat", abbr: "DK" },
  { name: "Estonia", taxType: "eu_vat", abbr: "EE" },
  { name: "Spain", taxType: "eu_vat", abbr: "ES" },
  { name: "Finland", taxType: "eu_vat", abbr: "FI" },
  { name: "France", taxType: "eu_vat", abbr: "FR" },
  { name: "Greece", taxType: "eu_vat", abbr: "GR" },
  { name: "Croatia", taxType: "eu_vat", abbr: "HR" },
  { name: "Hungary", taxType: "eu_vat", abbr: "HU" },
  { name: "Ireland", taxType: "eu_vat", abbr: "IE" },
  { name: "Italy", taxType: "eu_vat", abbr: "IT" },
  { name: "Lithuania", taxType: "eu_vat", abbr: "LT" },
  { name: "Luxembourg", taxType: "eu_vat", abbr: "LU" },
  { name: "Latvia", taxType: "eu_vat", abbr: "LV" },
  { name: "Malta", taxType: "eu_vat", abbr: "MT" },
  { name: "Netherlands", taxType: "eu_vat", abbr: "NL" },
  { name: "Poland", taxType: "eu_vat", abbr: "PL" },
  { name: "Portugal", taxType: "eu_vat", abbr: "PT" },
  { name: "Romania", taxType: "eu_vat", abbr: "RO" },
  { name: "Sweden", taxType: "eu_vat", abbr: "SE" },
  { name: "Slovenia", taxType: "eu_vat", abbr: "SI" },
  { name: "Slovakia", taxType: "eu_vat", abbr: "SK" },
  { name: "United Kingdom", taxType: "eu_vat", abbr: "GB" },
  { name: "United Kingdom", taxType: "gb_vat", abbr: "GB" },
  { name: "Hong Kong", taxType: "hk_br", abbr: "HK" },
  { name: "Indonesia", taxType: "id_npwp", abbr: "ID" },
  { name: "India", taxType: "in_gst", abbr: "IN" },
  { name: "Japan", taxType: "jp_cn", abbr: "JP" },
  { name: "Japan", taxType: "jp_rn", abbr: "JP" },
  { name: "Korea, Republic of", taxType: "kr_brn", abbr: "KR" },
  { name: "Liechtenstein", taxType: "li_uid", abbr: "LI" },
  { name: "Mexico", taxType: "mx_rfc", abbr: "MX" },
  { name: "Malaysia", taxType: "my_frp", abbr: "MY" },
  { name: "Malaysia", taxType: "my_itn", abbr: "MY" },
  { name: "Malaysia", taxType: "my_sst", abbr: "MY" },
  { name: "Norway", taxType: "no_vat", abbr: "NO" },
  { name: "New Zealand", taxType: "nz_gst", abbr: "NZ" },
  { name: "Russian Federation", taxType: "ru_inn", abbr: "RU" },
  { name: "Russian Federation", taxType: "ru_kpp", abbr: "RU" },
  { name: "Saudi Arabia", taxType: "sa_vat", abbr: "SA" },
  { name: "Singapore", taxType: "sg_gst", abbr: "SG" },
  { name: "Singapore", taxType: "sg_uen", abbr: "SG" },
  { name: "Thailand", taxType: "th_vat", abbr: "TH" },
  { name: "Taiwan", taxType: "tw_vat", abbr: "TW" },
  { name: "United States", taxType: "us_ein", abbr: "US" },
  { name: "South Africa", taxType: "za_vat", abbr: "ZA" },
];
